var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0"},[_c('v-col',{attrs:{"md":_vm.rowMd,"offset-md":_vm.offsetMd}},[_c('v-card',{attrs:{"flat":_vm.showPageTitle,"elevation":_vm.elevation,"tile":"","light":""}},[(_vm.showPageTitle)?_c('g-page-title',{attrs:{"icon":_vm.pageIcon,"title":_vm.pageTitle}}):_vm._e(),_c('v-card-text',[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }